import * as React from "react";

import { cn } from "./utils";

function Card({
  className,
  compact,
  ...props
}: React.ComponentProps<"div"> & { compact?: boolean }) {
  return (
    <div
      data-slot="card"
      className={cn(
        "bg-card text-card-foreground flex flex-col rounded-xl border",
        compact ? "gap-0 overflow-hidden" : "gap-6",
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({
  className,
  compact,
  ...props
}: React.ComponentProps<"div"> & { compact?: boolean }) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        compact ? "gap-0 py-1.5 px-4" : "gap-1.5 px-1 pt-6",
        className,
      )}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <h4
      data-slot="card-title"
      className={cn("leading-none", className)}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <p
      data-slot="card-description"
      className={cn("text-muted-foreground", className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className,
      )}
      {...props}
    />
  );
}

// compact 모드에서 Table 외곽 border 제거 (Card border와 겹침 방지)
const compactTableBorders = [
  "p-0",
  // Table 자체의 외곽 border 제거
  "[&_[data-slot=table]]:border-t-0",
  "[&_[data-slot=table]]:border-l-0",
  // 마지막 열 우측 border 제거 (Card border와 겹침)
  "[&_th:last-child]:border-r-0",
  "[&_td:last-child]:border-r-0",
  // 마지막 행 하단 border 제거 (Card border와 겹침)
  "[&_tbody_tr:last-child_td]:border-b-0",
].join(" ");

function CardContent({
  className,
  compact,
  ...props
}: React.ComponentProps<"div"> & { compact?: boolean }) {
  return (
    <div
      data-slot="card-content"
      className={cn(
        compact ? compactTableBorders : "px-6 [&:last-child]:pb-6",
        className,
      )}
      {...props}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-6 pb-6 [.border-t]:pt-6", className)}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
